import {ErrorBoundary} from "@/components/ErrorBoundary";
import {PATHS} from "@/constants/routes";
import {AuthLayout} from "@/layouts/AuthLayout/AuthLayout";
import {DashboardLayout} from "@/layouts/DashboardLayout/DashboardLayout";
import {NAV_REGISTRY} from "@/navigation/nav-config";
import {PrivateRoute} from "@/navigation/PrivateRoute";
import {PublicRoute} from "@/navigation/PublicRoute";
import {Login} from "@/pages/Auth/Login";
import {NotFound} from "@/pages/NotFound";
import {Suspense} from "react";
import {Navigate, RouterProvider, createBrowserRouter} from "react-router";

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <Navigate
        to="/dashboard"
        replace
      />
    ),
  },
  {
    element: <PublicRoute />,
    children: [
      {
        element: <AuthLayout />,
        children: [{path: PATHS.LOGIN, element: <Login />}],
      },
    ],
  },
  {
    element: <PrivateRoute />,
    children: [
      {
        element: <DashboardLayout />,
        children: NAV_REGISTRY.map(entry => ({
          path: entry.path,
          element: (
            <ErrorBoundary>
              <Suspense fallback={<div className="p-8 text-center text-(--color-text-tertiary)">Cargando…</div>}>
                <entry.component />
              </Suspense>
            </ErrorBoundary>
          ),
        })),
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
]);

export function App() {
  return <RouterProvider router={router} />;
}

export default App;
